//import React from 'react'

export default function GetUrl() {

    return "https://mxgsesoftware.com/digitalcallcenter/"


    //return "http://localhost:3102/digitalcallcenter/" // desarollo
    
}
